<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs6>
        <v-card color="grey lighten-3">
          <v-card-text>
            <v-icon>repeat</v-icon>
            <span class="subheading">Tweets <small>(today)</small></span>
            <div class="display-1">{{loading === true ? '-' : formatNumber(tweetCount)}}</div>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs6>
        <v-card color="grey lighten-3">
          <v-card-text>
            <v-icon>fa-newspaper</v-icon>
            <span class="subheading">Articles <small>(today)</small></span>
            <div class="display-1">{{loading === true ? '-' : formatNumber(articleCount)}}</div>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs6>
        <v-layout row align-center justify-space-around>
          <v-flex xs12 order-lg2>
            <v-card tile>
              <v-list two-line class="scroll-y">
                <template v-for="(item, index) in tweets.slice().reverse()">
                  <v-list-tile :key="index" avatar>
                    <v-list-tile-avatar @click="goToUser(item.screenName)" class="pointer">
                      <img :src="item.profileImageUrlHttps">
                    </v-list-tile-avatar>
                    
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.screenName" @click="goToUser(item.screenName)" class="pointer"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.text" class="pointer" @click="goToTweet(item.tweetTwitterId, item.screenName)"></v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        {{formatEpochDate(item.createdAt)}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="tweets[index+1]"></v-divider>
                </template>
                
                <template v-if="tweets.length === 0">
                  <div style="min-height: 40px;">
                    <pulse-loader :loading="true" :color="'orange'" style="margin-top: 25px;"></pulse-loader>
                  </div>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs6>
        <v-layout row align-center justify-space-around>
          <v-flex xs12 order-lg2>
            <v-card tile>
              <v-list two-line>
                <template v-for="(item, index) in articles.slice().reverse()">
                  <v-list-tile :key="index" avatar @click="goToArticle(item.url)">
                    <v-list-tile-avatar color="grey" tile><img v-if="item.imageUrl" :src="item.imageUrl">
                      <v-icon v-else dark>block</v-icon>
                    </v-list-tile-avatar>
                    
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.domain }}</v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.title"></v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        {{formatEpochDate(item.datePublished)}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="articles[index+1]"></v-divider>
                </template>
          
                <template v-if="articles.length === 0">
                  <div style="min-height: 40px;">
                    <pulse-loader :loading="true" :color="'orange'" style="margin-top: 25px;"></pulse-loader>
                  </div>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
  .pointer{ cursor: pointer; }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'
import axios from 'axios'
import SocketIO from 'socket.io-client'
import config from '@/helpers/config'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { format, subDays } from 'date-fns'
import { formatDateTimeWithYear, getQueryFromDateTime } from '@/helpers/formatters'

export default {
  data () {
    return {
      loading: false,
      room: null,
      socket: null,
      tweets: [],
      articles: [],
      tweetCount: 0,
      articleCount: 0
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters', 'getQuery', 'getCustomQuery'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setAllFilters', 'setCustomFilters', 'resetAllFilters', 'resetCustomFilters', 'setDirty', 'getDirty']),
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    formatEpochDate: function (value) {
      var date = new Date(Number(value))
      return (formatDateTimeWithYear(date))
    },
    goToUser (name) {
      window.open('https://twitter.com/' + name, '_blank')
    },
    goToTweet (id, name) {
      window.open('https://twitter.com/' + name + '/status/' + id, '_blank')
    },
    goToArticle (url) {
      window.open(url, '_blank')
    },
    getData: function () {
      this.loading = true
      const query = this.getCustomQuery({
        projectUuid: this.getFilters.projectUuid,
        fromDate: getQueryFromDateTime(format(subDays(new Date(), 0), 'YYYY-MM-DD'), 0, 0, 0),
        toDate: getQueryFromDateTime(format(subDays(new Date(), 0), 'YYYY-MM-DD'), 23, 59, 59),
        isDetected: this.getFilters.isDetected})

      axios.all([this.$store.dispatch('getTweetsCount', query), this.$store.dispatch('getArticlesCount', query)]).then(axios.spread((r1, r2) => {
        if (r1.data.status === 'SUCCESS' && r2.data.status === 'SUCCESS') {
          this.tweetCount = Number(r1.data.payload[0]._tweet_count)
          this.articleCount = Number(r2.data.payload[0]._article_count)
          this.loading = false
        } else {
          this.loading = false
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch(() => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
      })
    },
    newSocket () {
      let socket = SocketIO(config.socketIOUrl, { origins: '*:*' })
      this.socket = socket
      if (this.room) {
        this.socket.emit('join', this.room)
      }
      this.socket.on('connect', () => {
        this.notify({message: 'Connected to socketio ' + config.socketIOUrl, show: true})
      })
      this.socket.on('disconnect', () => {
        this.notify({message: 'Disconnected from socketio ' + config.socketIOUrl, show: true})
      })
      this.socket.on('tweet', (data) => {
        if (data.projectUuid !== this.getFilters.projectUuid) {
          return
        }
        this.tweetCount++
        if (this.tweets.length === 50) {
          this.tweets.slice(1)
        }
        this.tweets.push(data)
      })
      this.socket.on('article', (data) => {
        if (data.projectUuid !== this.getFilters.projectUuid) {
          return
        }
        this.articleCount++
        if (this.articles.length === 50) {
          this.articles.slice(1)
        }
        this.articles.push(data)
      })
    }
  },
  mounted: function () {
    for (var i = 0; i < this.currentUser.projects.length; i++) {
      if (this.currentUser.projects[i].uuid === this.getFilters.projectUuid) {
        this.room = this.currentUser.projects[i].uuid
      }
    }
    this.getData()
    this.newSocket()
  },
  watch: {
    '$route.query': {
      deep: true,
      handler (newVal, oldVal) {
        if (newVal.projectUuid !== oldVal.projectUuid) {
          this.tweets = []
          this.articles = []
          if (this.room) {
            this.socket.emit('leave', this.room)
          }
          for (var i = 0; i < this.currentUser.projects.length; i++) {
            if (this.currentUser.projects[i].uuid === newVal.projectUuid) {
              this.room = this.currentUser.projects[i].uuid
            }
          }
          this.getData()
          this.newSocket()
        }
      }
    }
  },
  components: {
    PulseLoader
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LiveView.vue